// extracted by mini-css-extract-plugin
export default {"Heading":"_Heading--tuVzQ","BodyContainer":"_BodyContainer--SPw79","ConfirmationMessage":"_ConfirmationMessage--jzwe2"};